import ClassDetail from '@/controllers/class/class-detail.js';

export default {
  extends: ClassDetail,

  computed: {
    homeroomTeachers() {
      return this.classInfo.homeroomTeachers || [];
    },
  },
}
